import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDog } from '@fortawesome/free-solid-svg-icons';

const HVASpinner = () => {
  return (
    <div
      className="d-flex justify-content-center align-items-end pt-2 w-100 text-primary"
      style={{ minHeight: '80px' }}
    >
      <div className="d-flex align-items-end">
        <FontAwesomeIcon icon={faDog} size="xs" shake />
        &nbsp;
        <FontAwesomeIcon icon={faDog} size="sm" bounce />
        &nbsp;
        <FontAwesomeIcon icon={faDog} size="lg" bounce />
        &nbsp;
        <FontAwesomeIcon icon={faDog} size="2x" bounce />
      </div>
    </div>
  );
};

export default HVASpinner;
